import React, { Component } from 'react';
import ReactSlider from 'react-slider';
import PropTypes from 'prop-types';

import './style.scss'
import {addClass} from "../../../../utils/common";
import { saveSIP } from "../../landing/Home/CalulcatorSection/action";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";

@connect((state) => {
    return {}
}, (dispatch) => {
    return {
        ...bindActionCreators({
            saveSIP,
        }, dispatch)
    }
})

export default class Slider extends Component{

    static propTypes = {
        min: PropTypes.number,
        max: PropTypes.number,
        step: PropTypes.number,
        defaultValue: PropTypes.number,
        unit: PropTypes.any,
        name: PropTypes.string,
        onChange: PropTypes.func,
        validateInput: PropTypes.func,
        restrictInput: PropTypes.func,
        className:PropTypes.string,
        value:PropTypes.any,
        homePage: PropTypes.bool,
        handleOnBlur: PropTypes.func,
        errorMsg: PropTypes.string,
        handleNext: PropTypes.func
    }

    constructor(props) {
        super(props);
        this.state = {
            value: "0",
            isValueUpdated:false
        }
        this.error;
    }
    componentDidMount(){
        let {value,min,className,saveSIP, homePage, max, name} = this.props;
        className && addClass(document.getElementsByClassName('my-slider')[0],className);
        let setValue = value ? value: min;
        this.setState({value:value}); // to make the span markers align properly
        let something = document.querySelector('.my-slider .bar.bar-1');
        if (homePage) {
            saveSIP && saveSIP(value);
        }
    }

    componentWillUpdate = (nextState) => {
        let something = document.querySelector('.my-slider .bar.bar-1');
        if(!this.state.isValueUpdated) {
            setTimeout(()=>{
                this.setState({
                    isValueUpdated:true,
                })
            })
        }
    }

    reset=()=>{
        let { min } = this.props;
        min && this.setStateAndUpdateParent(min);
    }

    onChange = (value)=>{
        let { min, max, restrictInput, saveSIP, homePage, handleNext, isNumeric, forGoalTravel, goalName } = this.props;
        handleNext && handleNext(!value ? true : false);
        let modValue, newValue;
        if(forGoalTravel && (goalName != "Travel") && value > 11){
            if(value > this.state.value) {
                newValue = (Math.trunc(value/12)*12)+12;
                if(newValue > max) newValue = max;
            }
            else if(value < this.state.value) {
                newValue = (Math.trunc(value/12)*12);
                if(newValue < min) newValue = min;
            }
            else if(value === this.state.value) {
                newValue = value;
                if(newValue < min) newValue = min;
            }
            // modValue = Math.round(value/12)*12;
            restrictInput ? !restrictInput(newValue) && this.setStateAndUpdateParent(newValue) : this.setStateAndUpdateParent(newValue);
        }
        else {
            restrictInput ? !restrictInput(value) && this.setStateAndUpdateParent(value) : this.setStateAndUpdateParent(value)
        }
        if(homePage) {
            saveSIP && saveSIP(value);
        }
    }

    onInputBlur=(event)=>{
        let {name,transformInput,handleOnBlur} = this.props;
        handleOnBlur && handleOnBlur(event.target.name, event.target.value);
        if(event.target.value) transformInput && this.setStateAndUpdateParent(transformInput(event.target.value));
        else this.reset();
    }

    setStateAndUpdateParent =(value)=>{
        let { onChange, name, validateInput } = this.props;
        this.setState({value:value},()=>{
            this.error = validateInput && validateInput(name,value);
            //onChange && onChange(value,name);
            onChange && onChange(name,value);
        })
    }

    jumpToNext=(event)=>{
        let code = (event.keyCode ? event.keyCode : event.which);
        if(__CLIENT__ && code==13 && typeof window !== 'undefined'){
            let nextQuesiton = document.getElementById('nextQuestion')
            nextQuesiton.click();
        }
    }

    render(){

        let {min ,max ,step, defaultValue, unit, name, maxlength, noFocus, homePage, errorMsg, dreamUnit, fromGoalJourney, forGoalTravel, minUnit, maxUnit, differentLowerUnit, goalName} = this.props;

        let sliderProps = {
            "defaultValue": defaultValue,
            "min": min,
            "max": max,
            "step": step,
            "handleClassName": "handle",
            "handleActiveClassName": "active",
            "barClassName": "bar",
            "withBars": true,
        }

        if(forGoalTravel && this.state.value > 12) {
            // sliderProps.step = 6;
        }

        let noOfSpans = 6,//(max-min)/step,
            marker = typeof window !== 'undefined' &&  document.getElementsByClassName('marker')[0],
            spanWidth = __CLIENT__  ?marker && (parseInt(window.getComputedStyle(marker).width)-2)/noOfSpans:0; // -2 as the width of border for container is 2px;

        let spans = [...Array(noOfSpans)].map((e, i) => <span key={i} style={{width:(spanWidth)+'px'}}></span>);
        //let spans = [...Array(noOfSpans)].map((e, i) => <span key={i}></span>);

        //console.log('noOfSpans',noOfSpans,'spanWidth',spanWidth,'marker',marker);
        return (

            <div className="my-slider">
                {homePage && <div className='home-page-input'>
                    <span>My Monthly investment will be</span>
                    <i className='icon-rupee-symbol' />
                    <input value={this.state.value} type='number'
                           onChange={(event)=>{this.onChange(event.target.value)}}
                           name={name}
                           onBlur={this.onInputBlur}
                           maxLength={maxlength}
                           onKeyPress={this.jumpToNext}
                        />
                </div>}
                {errorMsg && errorMsg !== 'empty input' && <span className='error-message'>
                                                <span className="asterick">* </span>{errorMsg}
                                             </span>}
                {forGoalTravel ? 
                <ReactSlider min={min*12} {...sliderProps} className='horizontal-slider' value={this.state.value}
                             onChange={this.onChange} ariaLabel='Choose the value'/> :
                <ReactSlider {...sliderProps} className='horizontal-slider' value={this.state.value}
                onChange={this.onChange} ariaLabel='Choose the value'/>}
                {!homePage && <div className='marker'>{spans}</div>}
                {forGoalTravel ? 
                <div className='limit-marker'>
                    <span className='lower'>{min}<i>{minUnit}</i></span>
                    <span className='upper'>{((name.includes('EXPENSE_MONTHS')) || (goalName === "Travel")) ? max : (max/12)}<i>{((name.includes('EXPENSE_MONTHS')) || (goalName === "Travel")) ? minUnit : ((maxUnit === 'years' && ((max/12) === 1)) ? 'year' : maxUnit)}</i></span>
                </div> :
                 <div className='limit-marker'>
                    <span className='lower'>{min}<i>{differentLowerUnit ? differentLowerUnit : unit}</i></span>
                    <span className='upper'>{max}<i>{unit}</i></span>
                </div>}
                {!homePage && (forGoalTravel ? 
                    <input autoFocus={noFocus ? false : true}
                        value={((name.includes('EXPENSE_MONTHS')) || (goalName === "Travel")) ? this.state.value : (this.state.value > 11 ? Math.round(this.state.value / 12) : this.state.value)} type={fromGoalJourney ? 'number' : 'tel'}
                        onChange={(event) => {
                            this.onChange(event.target.value)
                        }}
                        name={name}
                        min={min}   
                        max={max}
                        maxLength={maxlength}
                        onBlur={this.onInputBlur}
                        onKeyPress={this.jumpToNext}
                        onPaste={(e)=>{
                            if(fromGoalJourney){
                                e.preventDefault()
                                return false;
                            }
                        }} 
                        onCopy={(e)=>{
                            if(fromGoalJourney){
                                e.preventDefault()
                                return false;
                            }
                        }}
                        autoComplete={fromGoalJourney ? 'new-password' : ''}
                        // readOnly={fromGoalJourney ? true : false}
                        />
                    : <input autoFocus={noFocus ? false : true}
                        value={this.state.value} type={fromGoalJourney ? 'number' : 'tel'}
                        onChange={(event) => {
                            this.onChange(event.target.value)
                        }}
                        name={name}
                        min={min}   
                        max={max}
                        maxLength={maxlength}
                        onBlur={this.onInputBlur}
                        onKeyPress={this.jumpToNext}
                        onPaste={(e)=>{
                            if(fromGoalJourney){
                                e.preventDefault()
                                return false;
                            }
                        }} 
                        onCopy={(e)=>{
                            if(fromGoalJourney){
                                e.preventDefault()
                                return false;
                            }
                        }}
                        autoComplete={fromGoalJourney ? 'new-password' : ''}
                        // readOnly={fromGoalJourney ? true : false}
                        />)}

                <i className={dreamUnit && 'inputValue-unit'}>{unit || dreamUnit}</i>
                {fromGoalJourney && (forGoalTravel ? <span className="input-unit travel">{this.state.value > 11 ? (Math.round(this.state.value/12) === 1 ? (((name.includes('EXPENSE_MONTHS')) || (goalName === "Travel")) ? 'months' : 'year') : ((goalName === "Travel") ? 'months' : 'years')) : 'months'}</span> : <span className="input-unit">{this.state.value === 1 && differentLowerUnit ? differentLowerUnit : unit}</span>)}
                {this.error && <p className='error'>{this.error}</p>}
            </div>
        )
    }
}
